import { useEffect, useState } from "react";
import PageWrapper from "../../components/common/PageWrapper";
import Header from "../../components/common/Header";
import BodyWrapper from "../../components/common/BodyWrapper";
import Footer from "../../components/common/Footer";
import Wrapper from "../../components/dashboard/dashboardPartials/Wrapper";
import MealDetails from "../../components/dashboard/dashboardPartials/MealDetails";
import { useGeneral } from "../../components/contexts/GeneralContext";
import axios from "../../config/axios";
import { useParams } from "react-router-dom";
import FullScreenLoading from "../../components/common/loading/FullScreenLoading";
import ApiErrorMessage from "../../components/common/ApiErrorMessage";
import NoItemsFound from "../../components/common/NoItemsFound";
import MealCancelForm from "../../components/dashboard/dashboardPartials/MealCancelForm";

const MealSubsctiptionCancelPage = () => {
  const [loading, setLoading] = useState(true);
  const [content, setContent] = useState(null);
  const [error, setError] = useState("");
  const { discountCoupons } = useGeneral();
  const { id } = useParams();

  const fetchMealDetails = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(`/dashboard/subscriptions/${id}`);
      setContent(data);
      setError("");
    } catch (err) {
      console.error("Failed to load meal details:", err);
      setError("Failed to load meal details. Please try again later.");
      setContent(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMealDetails();
  }, [id]);

  return (
    <>
      {loading && <FullScreenLoading />}
      <PageWrapper loading={false} className="bg-bg min-h-screen">
        <Header code={discountCoupons} />
        <BodyWrapper className="lg:mb-0">
          <Wrapper goBack={true}
            component={
              !loading && error ? (
                <ApiErrorMessage
                  message1="Failed to load content"
                  message2="Please check your connection and try again."
                />
              ) : !loading && !content ? (
                <NoItemsFound
                  message1="Subscription details unavailable"
                  message2="Please check back later."
                />
              ) :content &&  (
                <MealCancelForm
                  meal={content}
                  fetchSubscriptions={fetchMealDetails} 
                />
              )
            }
          />
        </BodyWrapper>
        <Footer />
      </PageWrapper>
    </>
  );
};

export default MealSubsctiptionCancelPage;
